import { ContainerModule, interfaces } from 'inversify';
import { BackgroundController } from './background.controller';
import { BACKGROUND_EVENTS } from './background.events';
import type { IBackgroundController, IBackgroundEvents } from './background.interface';
import { BACKGROUND_MODULE_IDS } from './background.types';

const BackgroundModule = new ContainerModule((bind: interfaces.Bind) => {
  bind<IBackgroundController>(BACKGROUND_MODULE_IDS.BACKGROUND_CONTROLLER)
    .to(BackgroundController)
    .inSingletonScope();
  bind<IBackgroundEvents>(BACKGROUND_MODULE_IDS.BACKGROUND_EVENTS).toConstantValue(
    BACKGROUND_EVENTS,
  );
});

export { BackgroundModule };
